import { GET_MEMBERS } from "constants/members";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_MEMBERS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
